export default __webpack_public_path__ + "static/media/mena19.2f40775c.jpg";